import * as React from 'react'
import * as ReactRouter from 'react-router-dom'

import * as common from '@rushplay/common'
import * as Herz from '@rushplay/herz'

import * as Theming from './theming'
import { Card } from './card'
import { Heading } from './heading'
import { HtmlContent } from './html-content'

export function StaticPage() {
  const params = ReactRouter.useParams()
  const page = (params && params[0]) || ''

  const translate = Herz.I18n.useTranslate(
    () => [`${page}.title`, `${page}.content`],
    [page]
  )

  return (
    <Theming.Alternative>
      <common.Box flexDirection="column" display="flex" flexGrow="1">
        <common.Space p={2}>
          <Heading as="h1" level={2} color="page-nav-heading">
            {translate(`${page}.title`)}
          </Heading>
        </common.Space>
        <common.Box
          display="flex"
          p={[1, null, 4]}
          justifyContent="center"
          alignItems="flex-start"
          fontSize={2}
          flexGrow="1"
        >
          <Card p={[2, 4]} width="100%" maxWidth={[null, null, null, '1000px']}>
            <HtmlContent html={{ __html: translate(`${page}.content`) }} />
          </Card>
        </common.Box>
      </common.Box>
    </Theming.Alternative>
  )
}

export default StaticPage
